import {IPLocation} from "../location/IPLocation";
import {Region} from "./Region";
let $ = jQuery;

export class RegionService {
    public getRegionFromLocation(location: IPLocation): Promise<Region> {
        return new Promise<Region>((resolve, reject) => {
            $.get({
                url: "/wp-json/lg_pollen_count/v1/getNearestRegion",
                data: {
                    lat: location.latitude,
                    lng: location.longitude
                },
                success: (data) => resolve(data),
                error: (err) => reject(err)
            })
        });
    }
}



// WEBPACK FOOTER //
// ./assets/ts/src/services/region/RegionService.ts